import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import fetchRecommendations from 'Api/Recommendations/product-recommendations';
import { cleanRecommendations } from 'Api/Recommendations/utility';
import { fetchBySlugs } from 'Redux/ducks/algolia-calls';

const useProductRecommendations = ({
  product,
  forceTopSellers,
  forceBundle,
  forceBundleType,
}) => {
  const [loading, setLoading] = useState(true);
  const [hits, setHits] = useState(null);
  const [error, setError] = useState(null);
  const items = useSelector(state => state?.cart?.items);
  const userLibrary = useSelector(state => state?.userLibrary || []);
  const steamLibrary = useSelector(state => state?.steamLibrary || []);

  useEffect(() => {
    setLoading(true);

    const fetchTopSellers = async () => fetchRecommendations('cart');

    const fetchBundleRecommendations = async () => {
      const results = await fetchRecommendations('bundle');

      // If this is a software or book bundle we want to also fetch those results and the game bundle results
      // that if there are no software/book bundles to recommend we can still show the game bundle recommendations
      if (forceBundleType === 'book' || forceBundleType === 'software') {
        const additionalResults = await fetchRecommendations(`${forceBundleType}-bundle`);
        return [...results, ...additionalResults];
      }

      return results;
    };

    const filterAndSetHits = (hitsToFilter) => {
      const cleanHits = cleanRecommendations(
        hitsToFilter,
        product?.slug,
        items,
        [...userLibrary, ...steamLibrary],
        14,
      );
      setHits(cleanHits);
    };

    const returnError = (err) => {
      setLoading(false);
      setError(err);
    };


    if (forceTopSellers) {
      fetchTopSellers().then(filterAndSetHits).catch(returnError);
    } else if (forceBundle) {
      fetchBundleRecommendations().then(filterAndSetHits).catch(returnError);
    } else if (product?.smart_recommendations?.length > 4) {
      fetchBySlugs([product?.smart_recommendations])
        .then(results => filterAndSetHits(results[0]))
        .catch(returnError);
    } else if (product?.slug) {
      fetchRecommendations(product.type, product.franchises)
        .then(filterAndSetHits)
        .catch(returnError);
    } else {
      setLoading(false);
    }
  }, [
    forceTopSellers,
    forceBundle,
    forceBundleType,
    items,
    product?.slug,
    product?.type,
    product?.franchises,
    product?.smart_recommendations,
    userLibrary,
    steamLibrary,
  ]);

  return { hits, loading, error };
};

export default useProductRecommendations;
